import { useApiClient } from '../../contexts/ApiClientContext'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import {
  CreateEmailTokenRequest,
  EmailToken,
  GetEmailTokenRequest,
  VerifyEmailRequest,
} from '../../lib/generated/api'
import { useHandleApiError } from 'api/utils'

export const useVerifyEmail = () => {
  const { emailApi } = useApiClient()
  return useMutation((request: VerifyEmailRequest) =>
    emailApi.verifyEmail(request)
  )
}

export const useCreateEmailToken = () => {
  const queryClient = useQueryClient()
  const { emailApi } = useApiClient()
  const onError = useHandleApiError({ showMessage: false })

  queryClient.setMutationDefaults('createEmailToken', {
    mutationFn: (request: CreateEmailTokenRequest) =>
      emailApi.createEmailToken(request),
    onError,
  })

  return useMutation<EmailToken, unknown, CreateEmailTokenRequest>(
    'createEmailToken'
  )
}

export const useGetEmailToken = (request: GetEmailTokenRequest) => {
  const { emailApi } = useApiClient()
  return useQuery(
    ['useGetEmailToken', request.emailToken],
    () => emailApi.getEmailToken(request),
    {
      enabled: !!request.emailToken,
    }
  )
}
